export default "https://cdn-gra.amplement.io/statics/images/placeholder/placeholderGroup@2x.png";